import React from 'react';
import { Switch, Route, Redirect, Link, withRouter, matchPath } from 'react-router-dom';
import {
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import Customer from './customer';
import PendingProductInstance from './pending-product-instance';
import ProvisionPendingProductInstance from './pending-product-instance/provision';
import ProductInstance from './product-instance';
import User from './user';
import UserCreate from './user/create';
import Map from './map';
import Inspector from './inspector';
import Comm from './comm/table';
import Reporting from './report';
import Applications from './applications/table';
import ApplicationPermissions from './applications/permissions';
import ApplicationVersions from './applications/versions';
import Sidebar from 'react-sidebar';
import { classes } from './styles';
import CurrentApplicationLabel from './applications/current-label';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IS_DEVELOPMENT } from '../services/config';

class App extends React.Component {

  state = {

  };

  onLogout = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.props.onLogout();
  };

  getApplicationName(uuid) {

  }

  getSidebar() {
    return (
      <Nav className={`ml-auto ${classes.sidebar}`} navbar vertical>
        {
          [
            {
              to: '/pending-product-instance',
              name: 'Pending Product Instance'
            },
            {
              to: '/product-instance',
              name: 'Product Instance'
            },
            {
              to: '/customer',
              name: 'Customer'
            },
            {
              to: '/user',
              name: 'User'
            },
            {
              to: '/map',
              name: 'Map'
            },
            {
              to: '/inspector',
              name: 'Inspector'
            },
            {
              to: '/comm',
              name: 'Comm'
            },
            {
              to: '/report',
              name: 'Reports'
            },
            IS_DEVELOPMENT && {
              to: '/applications',
              name: 'Applications',
              children: [
                {
                  useLocation: true,
                  hidden: true,
                  to: '/applications/:uuid/permissions',
                  name: (
                    <React.Fragment>
                      <CurrentApplicationLabel />&nbsp;Permissions
                    </React.Fragment>
                  )
                },
                {
                  useLocation: true,
                  hidden: true,
                  to: '/applications/:uuid/versions',
                  name: (
                    <React.Fragment>
                      <CurrentApplicationLabel />&nbsp;Versions
                    </React.Fragment>
                  )
                }
              ]
            }
          ]
            .filter(value => value)
            .map(
              ({ to, name, children = [] }, index) => {
                const active = !!matchPath(this.props.location.pathname, {
                  path: to,
                  exact: false
                });
                const childNodes = children
                  .map(
                    ({ to, name, useLocation, hidden }, index) => {
                      const innerActive = !!matchPath(this.props.location.pathname, {
                        path: to,
                        exact: false
                      });
                      if (hidden && !innerActive) {
                        return null;
                      }
                      return (
                        <NavItem key={index} className={`${classes.sidebarItem} ${classes.sidebarSubItem}`} active={innerActive}>
                          <NavLink to={useLocation ? this.props.location.pathname : to} tag={Link}>
                            <FontAwesomeIcon icon={faArrowRight} />&nbsp;{name}
                          </NavLink>
                        </NavItem>
                      )
                    }
                  );
                const isChildren = childNodes
                  .filter(value => value)
                  .length > 0;
                return (
                  <React.Fragment key={index}>
                    <NavItem className={`${classes.sidebarItem} ${isChildren ? classes.sidebarParentItem : ''}`} active={active}>
                      <NavLink to={to} tag={Link}>
                        {name}
                      </NavLink>
                    </NavItem>
                    {
                      childNodes
                    }
                  </React.Fragment>
                )
              }
            )
        }
      </Nav>
    )
  }

  isMap() {
    return (this.props.location.pathname || '').indexOf('map') > -1;
  }

  render() {
    return (
      <React.Fragment>
        <div className={classes.header}>
          <Link to="/" className={classes.headerBrand}>
            <img className="brand" src="/assets/images/rewards-logo-color.png" />&nbsp;&nbsp;Rewards
          </Link>
          <div>
            <Link to="/logout" onClick={this.onLogout}>Logout</Link>
          </div>
        </div>
        <div className={classes.app}>
          <Sidebar
            shadow={false}
            sidebar={this.getSidebar()}
            docked={!this.isMap()}
          >
            <div className={classes.content}>
              <Switch>
                <Route path="/map" component={Map} />
                <Route path="/customer" component={Customer} />
                <Route path="/pending-product-instance/provision" exact component={ProvisionPendingProductInstance} />
                <Route path="/pending-product-instance/provision/:from" exact component={ProvisionPendingProductInstance} />
                <Route path="/pending-product-instance" exact component={PendingProductInstance} />
                <Route path="/product-instance" component={ProductInstance} />
                <Route path="/inspector" component={Inspector} />
                <Route path="/user/create" exact component={UserCreate} />
                <Route path="/user" exact component={User} />
                <Route path="/comm" exact component={Comm} />
                <Route path="/report" exact component={Reporting} />
                <Route path="/applications" exact component={Applications} />
                <Route path="/applications/:uuid/permissions" exact component={ApplicationPermissions} />
                <Route path="/applications/:uuid/versions" exact component={ApplicationVersions} />
                <Route
                  path="/logout"
                  render={() => {
                    this.onLogout(null);
                    return <p>Redirecting...</p>
                  }}
                />
                <Redirect to="/pending-product-instance" />
              </Switch>
            </div>
          </Sidebar>
        </div>
      </React.Fragment>
    );
  }

}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/app/app.js